var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcountdark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0823 5.40036C14.0823 2.41782 11.5843 0 8.5028 0C5.42132 0 2.92328 2.41782 2.92328 5.40036C2.92328 8.38289 5.42132 10.8007 8.5028 10.8007C11.5843 10.8007 14.0823 8.38289 14.0823 5.40036ZM10.81 13.5498C9.28032 13.4338 7.74364 13.4338 6.21399 13.5498C5.37778 13.5934 4.54555 13.6915 3.72297 13.8434C1.93054 14.1548 0.772353 14.7331 0.285179 15.6228C0.0941985 15.9705 -0.00376583 16.3589 0.000110731 16.7527C0.00173621 17.144 0.102756 17.529 0.294371 17.8737C0.790737 18.7633 1.94892 19.3327 3.72297 19.653C4.54194 19.8082 5.37134 19.9063 6.2048 19.9466C6.48056 19.9466 6.76551 19.9644 7.05965 20H8.46602C9.24734 20 10.0195 20 10.7916 19.9199C11.625 19.874 12.4542 19.7729 13.2734 19.6174C15.1118 19.3149 16.224 18.7278 16.7204 17.8381C17.0932 17.1437 17.0932 16.3171 16.7204 15.6228C16.224 14.7331 15.0658 14.1815 13.2918 13.8434C12.472 13.6936 11.6429 13.5955 10.81 13.5498Z",
    fill: "#18173C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcountdark);
export default __webpack_public_path__ + "static/media/acountdark.0b711580b42a0bab3bea26323ba0e531.svg";
export { ForwardRef as ReactComponent };